export default "__VITE_ASSET__8BCtSHvZ__"